module.exports = __webpack_public_path__ + "img/794f361.png";